<template>
<div class='profile-account'>
  <!-- 弹窗 -->
  <!-- <cellphone-dialog ref='cellphone-dialog' />
  <change-password-dialog ref='reset-password-dialog' />
  <wx-connection-dialog ref='wx-connection-dialog' /> -->

  <div class='infos pane'>
    <h1 class='email'>{{user.email || user.cellphone}}</h1>
    <div class='sub-infos'>
      <div class='avatar img' :style="{'backgroundImage': 'url('+user.profile_picture+')'}">
        <ssuploader class='avatar-uploader-btn' :defaultBtn="false" :url="avatarUploadUrl" :data="{'_method': 'PUT'}" name='user[profile_picture]' :extensions="extensions" :accept="accept" :uploading.sync="avatarOnUploading" @complete="avatarUploadComplete" />
        <div class='ppj-icon-spinner' style="margin-left: 42.222222%;margin-top: 42.2222222%;" v-if="avatarOnUploading"></div>
      </div>

      <table class='text-table'>
        <tr>
          <td class='label'>用户名称</td>
          <td class='data'>
            {{user.nickname}}
            <a v-on:click="rename()" class='text-btn'>修改</a>
          </td>
        </tr>
        <tr>
          <td>账户类型</td>
          <td>
            {{ $store.getters['user/organization'] ? '企业用户' : '个人账户'}}
            <!-- <a v-on:click='' class='text-btn'>认证企业账户</a> -->
          </td>
        </tr>
        <tr>
          <td>手机号</td>
          <td v-if='user.cellphone'>
            {{user.cellphone}}
            <a v-on:click="cellphoneDialog()" class='text-btn'>修改</a>
          </td>
          <td v-else>
            无
            <a v-on:click="cellphoneDialog()" class='text-btn'>绑定手机号</a>
          </td>
        </tr>
        <tr v-if="user.occupation_verified">
          <td>教师认证</td>
          <td>
            <span>已认证</span>
            <router-link to="/teacher" class='text-btn' style="margin-left: 0;">去认证</router-link>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class='quota pane'>
    <span class='title'>账户额度</span>
    <div class='quota-item'>
      <span class='numbers' v-if="quotas.permanents === null">无限制</span>
      <span class='numbers' v-else>
          {{quotas.permanents_left}}/{{quotas.permanents}}
      </span>
      <span class='sub-title' v-once>{{$t('projectQuota')}}</span>
    </div>
    <div class='quota-item'>
      <span class='numbers' v-if="quotas.logos === null">无限制</span>
      <span class='numbers' v-else>
            {{quotas.logos_left}}/{{quotas.logos}}
        </span>
      <span class='sub-title'>LOGO 设置</span>
    </div>
    <div class='quota-item'>
      <span class='numbers' v-if="quotas.exports === null">无限制</span>
      <span class='numbers' v-else>
            {{quotas.exports_left}}/{{quotas.exports}}
        </span>
      <span class='sub-title'>导出次数</span>
    </div>
  </div>

  <div class='actions pane'>
    <table>
      <tr>
        <td>微信绑定</td>
        <td>
          <span v-if="user.wechat_nickname" style='margin-left: 1.5em;'>
              {{user.wechat_nickname}}
              <a class='text-btn' v-on:click="wxDisconnected">解除绑定</a>
          </span>
          <a v-else class='text-btn' v-on:click="wxConnectionDialog()">去绑定</a>
        </td>
      </tr>
      <tr>
        <td>密码</td>
        <td><a class='text-btn' v-on:click="changePasswordDialog()">修改密码</a></td>
      </tr>
    </table>
  </div>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "projectQuota": "@:common.project额度",
    "disconnectWXhint": "解除微信绑定后，您的微信号将不会收到@:common.project生成状态的推送，以及一些与微信相关的功能也会收到限制。是否继续？"
  }
}
</i18n>

<style lang='scss' scoped>
.profile-account {
    .text-btn {
        margin-left: 1.5em;
    }
    .infos {
        padding-top: 1px;
        .email {
            padding-left: 2 * $padding-base;
        }

        .sub-infos {
            border-top: $border-base;
            padding: 2 * $padding-base;

            $avatar-width: 90px;
            .avatar {
                float: left;
                position: relative;
                width: $avatar-width;
                height: $avatar-width;
            }

            .text-table {
                margin-left: $avatar-width + 4 * $padding-base;
                tr {
                    line-height: 2em;
                }

                .label {
                    width: 100px;
                }
            }
        }
    }

    .quota {
        overflow: hidden;
        .title {
            float: left;
        }
        .quota-item {
            float: left;
            width: 100px;
            text-align: center;
            line-height: 1.5em;
            margin-left: 2em;
            > span {
                display: block;
            }
        }
    }

    .actions {
        table {
            tr {
                line-height: 2em;
            }
        }
    }
}
</style>

<script>
import { mapState } from 'vuex'
import { createDialog } from '@/assets/scripts/dialog'
import WxConnectionDialog from './wx_connection.dialog'
import CellphoneDialog from './cellphone.dialog'
import ChangePasswordDialog from './change_password.dialog'
import SSUploader from '@/components/widgets/ss_uploader.input'

export default {
  data() {
    return {
      // uploader parameters
      avatarUploadUrl: `${process.env.API_ROOT}profile`,
      extensions: ['png', 'gif', 'jpeg', 'jpg'],
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      avatarOnUploading: false,
      wxConnectionDialog: createDialog(WxConnectionDialog),
      cellphoneDialog: createDialog(CellphoneDialog),
      changePasswordDialog: createDialog(ChangePasswordDialog)
    }
  },
  components: {
    // 'cellphone-dialog': CellphoneDialog,
    // 'change-password-dialog': ChangePasswordDialog,
    // 'wx-connection-dialog': WxConnectionDialog,
    'ssuploader': SSUploader
  },
  computed: {
    name: {
      get() {
        return this.user.nickname
      },
      set(value) {
        this.$store.dispatch('user/update', {
          nickname: value
        })
      }
    },
    ...mapState({
      user: state => state.user.info,
      quotas: state => state.quota.summary
    })
  },
  methods: {
    rename() {
      let vm = this
      vm.$prompt(' ', '修改昵称', {
        confirmButtonText: '保存',
        cancelButtonClass: 'el-button--text',
        inputPattern: /^\S+$/,
        inputErrorMessage: '昵称不能为空或包含空格',
        inputValue: vm.name
      }).then(res => {
        vm.name = res.value
      }).catch(_ => {})
    },
    avatarUploadComplete() {
      this.$store.dispatch('refresh')
    },
    wxDisconnected() {
      let vm = this

      vm.$confirm(vm.$t('disconnectWXhint'), '解除微信绑定', {
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--danger',
        cancelButtonClass: 'el-button--text'
      }).then(_ => {
        vm.$store.dispatch('user/wxDisconnect').then(_ => {
          vm.$message('解绑成功')
        })
      }).catch(_ => {})
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // if there is a query parameter called 'verify', prompt related dialog
      vm.$store.dispatch('refresh')

      if (to.query.verify === 'mobile') {
        vm.$refs['cellphone-dialog'].open()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?9b5d5bd4